<script>
    import { createEventDispatcher, onMount } from "svelte";
    export let stripe;
    export let disabled = false;
    export let goButtonText = "Go";
    export let cancelButtonText = "Cancel";
    export let showCancel = false;
    let cardComplete = false;
    let cardError = null;
    let cardElement = null;
    const dispatch = createEventDispatcher();
  
    onMount(() => {
      let elements = stripe.elements();
      let style = {
        base: {
          color: "#32325d",
          fontFamily: "-apple-system,Roboto,sans-serif",
          fontSize: "16px",
          "::placeholder": {
            color: "#ccc",
          },
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      };
      cardElement = elements.create("card", { style: style, hideIcon: true });
      cardElement.mount("#card-element");
      cardElement.on("change", showCardError);
    });
  
    function showCardError(event) {
      cardComplete = event.complete;
      if (event.error) cardError = event.error.message;
      else cardError = null;
    }
  
    function submit(evt) {
      dispatch('submit', { event: evt, cardComplete, cardElement });
    }
  </script>
  
  <style>
    .card-element {
      height: 40px;
      padding: 10px 12px;
      width: 100%;
      color: #32325d;
      background-color: white;
      border: 1px solid transparent;
      border-radius: 4px;
      box-shadow: 0 1px 3px 0 #e6ebf1;
      -webkit-transition: box-shadow 150ms ease;
      transition: box-shadow 150ms ease;
    }
    .card-element--focus {
      box-shadow: 0 1px 3px 0 #cfd7df;
    }
    .card-element--invalid {
      border-color: #fa755a;
    }
    .card-element--webkit-autofill {
      background-color: #fefde5 !important;
    }
    .card-errors {
      color: #fa755a;
      margin-top: 5px;
      margin-left: 5px;
      font-size: 0.8em;
    }
  </style>
  
  <form
    id="payment-form"
    on:submit={(e) => {
      dispatch('submit', { event: e });
    }}>
    <div id="card-element" class="card-element" />
    {#if cardError}
      <div id="card-errors" class="card-errors" role="alert">{cardError}</div>
    {/if}
  
    <div style="margin-top: 20px;">
      <button class="btn waves-effect blue-grey" type="submit" disabled={disabled || !cardComplete} on:click={(e) => { submit(e); }}>{goButtonText}</button>
  
      {#if showCancel}
      <a
        href="#!"
        class="btn-flat"
        on:click={() => {
            dispatch('cancel');
        }}>
        {cancelButtonText}
      </a>
      {/if}
    </div>
  </form>
  